module.exports = __webpack_public_path__ + "img/utahraptor.98a35916.png";